// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__zITp9","resendInfoText":"OnGoingPaymentBox_resendInfoText__19kHR"};